import React, {useState, useCallback, useRef} from "react";
import {useParams, useHistory} from "react-router-dom";
import Select from "react-select";

import GenericTemplate from "../../../templates/GenericTemplate";
import {apollo_useStyles, options_batch_status} from "../../../atom/Apollo_styles";
import {
  APOLLO_PROFILE_SYSTEM_OPERATOR,
  APOLLO_GROUP_OPERATOR,
  ApolloPageUsagePermission,
  IsAccountGroupAuth,
} from "../../../atom/Apollo_Authorization";
import {
  crassetcsvuploadms_path,
  post_ms_batch_path,
  get_ms_batch_path,
  get_ms_batch_download_path,
  get_ms_adgroups_path,
  get_ms_account_path,
  get_ms_campaignNames_path
} from "../../../atom/Apollo_links";
import {ApolloMessage, CustomizedSnackbars} from "../../../atom/Apollo_Mesasge";
import {ApolloContext} from "../../../atom/Apollo_Context";
import {ApolloDataTable} from "../../../atom/Apollo_DataTable";
import {ApolloFileUpload} from "../../../molecule/Apollo_FileUpload";

import axios from "axios";
import moment from "moment";

import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions/CardActions";
import Button from "@material-ui/core/Button";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import IconButton from "@material-ui/core/IconButton"
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import {DraftCsvUploadResultMs, ImmunityMessage} from "./CSVUploadModelMs";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../../atom/Apollo_Breadcrumbs2";
import {BLANK, DATE_TIME_SUFFIX} from "./common/CommonConst";
import {MUIDataTableColumnDef, SelectableRows} from "mui-datatables";
import {RESULT_KBN} from "../../../common/Apollo_CommonConst";

import {ApolloEventRecord, ItemList} from "../../../atom/Apollo_EventRecord";

/**
 * Tab画面パーツ
 */
function a11yProps(index: any) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const {children, value, index, ...other} = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {children}
    </div>
  );
}

const valueToLabel = function (value: any, options: Array<{ value: any; label: string }>): string {
  let option = options.find(option => option.value === value)
  if (!option) {
    return "";
  } else {
    return option.label;
  }
};

function rand() {
  return Math.round(Math.random() * 20) - 10;
}

/**
 * base64をBlob(csv)に変換する
 * @param {string} base64 - base64文字列
 * @returns {Blob} base64をBlob(csv)に変換した値
 */
function convertBlob(base64: string) {
  var bin = atob(base64.replace(/^.*,/, ''));
  var buffer = new Uint8Array(bin.length);

  for (var i = 0; i < bin.length; i++) {
    buffer[i] = bin.charCodeAt(i);
  }

  try {
    var blob = new Blob([buffer.buffer], {
      type: 'text/csv'
    });
  } catch (e) {
    return false;
  }
  return blob;
}

const OperationCSVUploadMs: React.FC = () => {
  const {state, dispatch} = React.useContext(ApolloContext);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const classes = apollo_useStyles();
  const history = useHistory();

  const [tabstate, setTabstate] = useState(0);
  const [binary, setBinary] = useState("");
  const [imageFiles, setImageFiles] = useState("");
  const processing = useRef(false);

  const {accountgroupid, accountid, platformaccountid} = useParams<{
    accountgroupid: string,
    accountid: string,
    platformaccountid: string
  }>();

	// アカウントグループの権限取得
	const isAccountGroupAuth = IsAccountGroupAuth(Number(accountgroupid), APOLLO_GROUP_OPERATOR);

  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 15,
    breadId: 1,
    queries: [],
    menu: {
      id: 2,
      accountId: platformaccountid,
      accountName: "",
    },
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }

  // ダウンロード
  const handleDownload = () => {
    if (adgroupDL !== "") {
      let isExists = false;

      adgroups.forEach(function (value: any) {
        if (adgroupDL === value.adGroupId) {
          isExists = true;
        }
      });

      if (!isExists) {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: "選択されたキャンペーン配下に広告グループIDが存在しません。"
          }
        });
        return;
      }
    }

    const url = `${process.env.REACT_APP_API_ENDPOINT}${get_ms_batch_download_path}?ad_account_id=${platformaccountid}&campaign_id=${campaignDL}&ad_group_id=${adgroupDL}`;

    axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${state.accesstoken}`,
      }
    }).then((response) => {
      if (response.data.resultcode == 0) {
        let csvFileName = `mail_${accountid}_${platformAccountName}`;
        if (campaignDL !== "") {
          csvFileName += "_" + campaignDL
        }
        if (adgroupDL !== "") {
          csvFileName += "_" + adgroupDL
        }
        csvFileName += `_${moment().format("YYYYMMDDHHmmss")}.csv`
        const blob = convertBlob(response.data.result);
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = csvFileName;
        link.click();
      } else {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: `CSVのダウンロードに失敗しました。${response?.data?.message ?? ""}`
          }
        });
      }
    }).catch((error) => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "CSVのダウンロードに失敗しました。"
        }
      });
    });
  }

  const dataToCsvBlob = (data: any[][], header: any[]): Blob => {
    const body = data
    const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
    const csvData = body?.map(line => line.join(',')).join('\r\n');

    const blob = new Blob([bom, csvData], {
      type: 'text/csv'
    })

    return blob
  }

  // アップロード
  const handelSave = async () => {
    if (processing.current) return;
    processing.current = true;
    let isSuccess = false;
    let targetID = "";
    let targetName = "";

    if (state.current.accountId === 0) {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "広告アカウントIDを選択してください。"
        }
      });
      processing.current = false;
      return;
    }

    if (!imageFiles) {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "ファイルを選択してください"
        }
      });
      processing.current = false;
      return;
    }

    const params = new FormData();
    params.append('adAccountId', platformaccountid);
    params.append('batchCsv', imageFiles[0]);
    params.append('userId', String(state.userprofile.userId));

    // @ts-ignore
    const file: File = imageFiles[0];

    let itemList: ItemList[] = [
      {
        key: "アップロードファイル名",
        beforeValue: "",
        afterValue: file.name,
      },
    ]
    // 実行時
    ApolloEventRecord({
      eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      logType: "execute",
      result: "",
      userID: state.userprofile.userId,
      userName: state.userprofile.userName,
      accessToken: state.accesstoken ,
      accountGroupID : state.current.accountGroupId,
      accountGroupName: state.current.accountGroupName,
      accountID : state.current.accountId,
      accountName: state.current.accountName,
      campaignID: "", // キャンペーンID
      campaignName: "", // キャンペーン名
      adGroupID: "", // 広告グループID
      adGroupName: "", // 広告グループ名
      menu: "",
      displayName: "一括処理アップロード(メール広告)画面",
      category: "一括処理アップロード",
      actionType: "アップロード",
      targetID: "",
      targetName: "",
      itemList: itemList,
    });

    const url = `${process.env.REACT_APP_API_ENDPOINT}${post_ms_batch_path}`;

    await axios.post(
      url,
      params,
      {
        headers: {
          'Authorization': `Bearer ${state.accesstoken}`,
        }
      }
    ).then((response) => {
      if (response.data.resultcode == 0) {
        isSuccess = true;
        if (response.data.adBatchId) targetID = response.data.adBatchId;
        targetName = file.name;
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "info",
            message: "アップロードを受付けました。"
          }
        });
      } else if (response.data.resultcode === RESULT_KBN.INFO) {
          setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "warning",
            message: response?.data?.message ?? ""
          }
        });
      } else {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: `CSVのアップロードに失敗しました。${response?.data?.message ?? ""}`
          }
        });
      }
    }).catch((error) => {
      if (error?.response?.status === 500) {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: "500 Internal Server Error"
          }
        });
        return;
      }

      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "CSVのアップロードに失敗しました。"
        }
      });
    }).finally(() => {
      // 実行結果
      ApolloEventRecord({
        eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        logType: "result",
        result: isSuccess? "成功" : "失敗",
        userID: state.userprofile.userId,
        userName: state.userprofile.userName,
        accessToken: state.accesstoken ,
        accountGroupID : state.current.accountGroupId,
        accountGroupName: state.current.accountGroupName,
        accountID : state.current.accountId,
        accountName: state.current.accountName,
        campaignID: "", // キャンペーンID
        campaignName: "", // キャンペーン名
        adGroupID: "", // 広告グループID
        adGroupName: "", // 広告グループ名
        menu: "",
        displayName: "一括処理アップロード(メール広告)画面",
        category: "一括処理アップロード",
        actionType: "アップロード",
        targetID: targetID,
        targetName: targetName,
        itemList: itemList,
      });

      if (isSuccess) {
        setTimeout(
          function () {
            window.location.reload();
          },
          "2000"
        );
      }

      processing.current = false;
    });
  };

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTabstate(newValue);
  };

  const downloadCsvFile = async (url: string) => {
    const baseUrl = url.replace(/\?.*$/, "");
    const link = document.createElement("a");
    link.href = baseUrl;
    link.click();
  }

  type MsCampaign = {
    campaign_id: string,
    campaign_name: string,
    ad_account_id: string,
  }

  type AdGroup = {
    adGroupId: number,
    adGroupName: string,
  }

  const [uploadResult, setUploadResult] = useState<DraftCsvUploadResultMs[]>([]);
  const [campaigns, setCampaigns] = useState<MsCampaign[]>([]);
  const [adgroups, setAdgroups] = useState<AdGroup[]>([]);
  const [platformAccountId, setPlatformAccountId] = useState("");
  const [platformAccountName, setPlatformAccountName] = useState("");

  React.useEffect(() => {
    let accountGroupId = state.current.accountGroupId;
    let accountId = state.current.accountId;
    setPlatformAccountId(platformaccountid);

    var url = `${process.env.REACT_APP_API_ENDPOINT}${get_ms_account_path}/${accountGroupId}/${platformaccountid}`;
    axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${state.accesstoken}`,
      },
    }).then((response) => {
      if (response.data.resultcode == 0) {
        setPlatformAccountName(response.data.result.adAccountsName)
      } else {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: `広告アカウント情報の取得に失敗しました。${response?.data?.message ?? ""}`
          }
        });
      }
    }).catch(err => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "広告アカウント情報の取得に失敗しました。"
        }
      });
    });

    url = `${process.env.REACT_APP_API_ENDPOINT}${get_ms_campaignNames_path}/${platformaccountid}`;
    axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${state.accesstoken}`,
        },
    }).then((response) => {
      if (response.data.resultcode === 0) {
        setCampaigns(response.data.result ?? [])
      } else {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: `キャンペーン情報の取得に失敗しました。${response?.data?.message ?? ""}`
          }
        });
      }
    }).catch(err => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "キャンペーン情報の取得に失敗しました。"
        }
      });
    });

    // CSVアップロード結果
    url = `${process.env.REACT_APP_API_ENDPOINT}${get_ms_batch_path}?ad_account_id=${platformaccountid}&ad_batch_id=0&per_page=100&page=1&sort=1&direction=2`;

    axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${state.accesstoken}`,
      }
    }).then((response) => {
      if (response.data.resultcode === 0) {
        setUploadResult(response.data.result ?? []);
      } else {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: `CSVアップロード結果の取得に失敗しました。${response?.data?.message ?? ""}`
          }
        });
      }
    }).catch((error) => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "CSVアップロード結果の取得に失敗しました。"
        }
      });
    });
  }, [])

  let options_campaign = campaigns.map(campaign => ({
    value: campaign.campaign_id,
    label: `${campaign.campaign_id}_${campaign.campaign_name}`
  }))

  const [campaignDL, setCampaignDL] = useState("");
  const [adgroupDL, setAdgroupDL] = useState("");
  const [isUpdate, setIsUpdate] = useState(false);

  const changeAdgroup = (value1: any) => {
    setAdgroupDL(value1.value)
  };

  const changeCampaign = (value1: any) => {
    setCampaignDL(value1.value)
    setAdgroupDL("")

    // 広告グループ一覧
    let url = `${process.env.REACT_APP_API_ENDPOINT}${get_ms_adgroups_path}/${platformaccountid}/${value1.value}`;

    axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${state.accesstoken}`,
      }
    }).then((response) => {
      if (response.data.resultcode === 0) {
        setAdgroups(response.data.result ?? []);
      } else {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: `広告グループ情報の取得に失敗しました。${response?.data?.message ?? ""}`
          }
        });
      }
      setIsUpdate(!isUpdate)
    }).catch((error) => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "広告グループ情報の取得に失敗しました。"
        }
      });
    });
  };

  type adgroup1 = {
    value: number,
    label: string,
  };

  const initAdgroup1: adgroup1[] = [{
    value: 0,
    label: "",
  }]

  let options_adgroup = initAdgroup1;
  if (adgroups !== null) {
    options_adgroup = adgroups.map(adgroup => ({
      value: adgroup.adGroupId,
      label: `${adgroup.adGroupId}_${adgroup.adGroupName}`
    }))
  }

  // テンプレート取得
  const handleDownloadTemplete = () => {
    let link = document.createElement('a');
    link.href = "/csv/ms/operation_csv_template.csv";
    link.download = "mail_operation_csv_template.csv";
    link.click();
  }

  const columns: MUIDataTableColumnDef[] = [
    {
      name: "ad_batch_id",
      label: "一括処理ID",
      options: {
        filter: false,
        sort: false,
      }
    },
    {
      name: "upload_date",
      label: "アップロード日時",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any) => {
          return moment(value.replace(DATE_TIME_SUFFIX, BLANK)).format("YYYY-MM-DD HH:mm:ss");
        },
      }
    },
    {
      name: "batch_status",
      label: "ステータス",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any) => {
          return valueToLabel(value, options_batch_status);
        },
      }
    },
    {
      name: "all_number",
      label: "全件数",
      options: {
        filter: false,
        sort: false,
      }
    },
    {
      name: "success_number",
      label: "取り込み成功件数",
      options: {
        filter: false,
        sort: false,
      }
    },
    {
      name: "failed_number",
      label: "取り込みエラー件数",
      options: {
        filter: false,
        sort: false,
      }
    },
    {
      name: "upload_csv_file_url",
      label: "アップロード済み入稿CSV",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any) => {
          return (
            value
            ? <IconButton aria-label="download" onClick={() => downloadCsvFile(value)}>
              <CloudDownloadIcon/>
            </IconButton>
            : undefined
          );
        },
      }
    },
    {
      name: "upload_err_csv_file_url",
      label: "エラーCSV",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any) => {
          return (
            value
            ? <IconButton aria-label="download" onClick={() => downloadCsvFile(value)}>
              <CloudDownloadIcon/>
            </IconButton>
            : undefined
          );
        },
      }
    },
  ];

  const selectableRows: SelectableRows = 'none';
  const options = {
    filter: false,
    download: false,
    print: false,
    search:false,
    sort: false,
    sortOrder: false,
    viewColumns:false,
    selectableRows: 'none',
    pagination:false,
    jumpToPage: false,
    expandableRows: false,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    textLabels:{
      body: {noMatch: "該当データが存在しません"}
    },
  }

  return (
    <GenericTemplate title="">
      <CustomizedSnackbars/>
      <ApolloPageUsagePermission role={APOLLO_GROUP_OPERATOR} profile={APOLLO_PROFILE_SYSTEM_OPERATOR}>
        <ApolloBreadcrumbs2 data={breadcrumbsData}/>
        <Grid container>
          <Grid item xs={8}>
            <Tabs value={tabstate} onChange={handleChange} aria-label="creative tabs">
              <Tab label="アップロード" {...a11yProps(0)} />
              <Tab label="入稿CSVアップロード結果一覧" {...a11yProps(1)} />
              <Tab label="入稿CSVダウンロード" {...a11yProps(2)} />
            </Tabs>
          </Grid>
          <Grid item xs={4}>
            <Grid container justify={"flex-end"}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {history.push(`${crassetcsvuploadms_path}${accountgroupid}/${accountid}/${platformaccountid}`)}}
                className={classes.button}
              >
                広告アセット一括アップロード
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <TabPanel value={tabstate} index={0}>
          <ApolloFileUpload
            setBinary={setBinary}
            setFiles={setImageFiles}
            accept=".csv"
            isMultiple={false}
            handleSave={handelSave}
            handleDownloadTemplete={handleDownloadTemplete}
            immunityMessage={ImmunityMessage}
            processing={processing}
            title={"アップロードファイル"}
            isUploadDisable={!isAccountGroupAuth}
          />
        </TabPanel>
        <TabPanel value={tabstate} index={1}>
          <Card className={classes.root} square variant="outlined">
            <ApolloDataTable
              data={uploadResult}
              columns={columns}
              options={options}
              title=""
            />
          </Card>
        </TabPanel>
        <TabPanel value={tabstate} index={2}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
              <Card className={classes.root} square variant="outlined" style={{height: "600px"}}>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    検索条件
                  </Typography>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="subtitle1" gutterBottom component="div">
                        広告アカウント(固定）
                      </Typography>
                      <Select
                        value={{
                          label: platformAccountName, value: platformAccountName
                        }}
                        closeMenuOnSelect={true}
                        isDisabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="subtitle1" gutterBottom component="div">
                        キャンペーン
                      </Typography>
                      <Select
                        closeMenuOnSelect={true}
                        options={options_campaign}
                        onChange={changeCampaign}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="subtitle1" gutterBottom component="div">
                        広告グループ
                      </Typography>
                      <Select
                        closeMenuOnSelect={true}
                        options={options_adgroup}
                        onChange={changeAdgroup}
                        key={isUpdate ? "Loaded" : "Loading"}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
                <CardActions className={classes.cardaction}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleDownload}
                    className={classes.button}>
                    ＣＳＶダウンロード
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        </TabPanel>
      </ApolloPageUsagePermission>
    </GenericTemplate>
  );
};

export default OperationCSVUploadMs;
